/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoadingRouteImport } from './routes/loading'
import { Route as GetStartedRouteImport } from './routes/get-started'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as R404RouteImport } from './routes/404'
import { Route as R401RouteImport } from './routes/401'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResourcesIndexRouteImport } from './routes/resources/index'
import { Route as SolutionsProfessionalsRouteImport } from './routes/solutions/professionals'
import { Route as SolutionsConsultingRouteImport } from './routes/solutions/consulting'
import { Route as SolutionsClientsRouteImport } from './routes/solutions/clients'
import { Route as ResourcesResearchRouteImport } from './routes/resources/research'
import { Route as ResourcesCaseStudiesRouteImport } from './routes/resources/case-studies'
import { Route as ResourcesBlogRouteImport } from './routes/resources/blog'
import { Route as LegalSubprocessorsRouteImport } from './routes/legal.subprocessors'
import { Route as LegalPlatformEulaRouteImport } from './routes/legal.platform-eula'
import { Route as LegalIntendedPurposeRouteImport } from './routes/legal.intended-purpose'
import { Route as LegalEulaRouteImport } from './routes/legal.eula'
import { Route as LegalDpaRouteImport } from './routes/legal.dpa'
import { Route as ResourcesResearchSlugRouteImport } from './routes/resources/research.$slug'
import { Route as ResourcesCaseStudiesSlugRouteImport } from './routes/resources/case-studies.$slug'
import { Route as ResourcesBlogSlugRouteImport } from './routes/resources/blog.$slug'

const TrustRoute = TrustRouteImport.update({
  id: '/trust',
  path: '/trust',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoadingRoute = LoadingRouteImport.update({
  id: '/loading',
  path: '/loading',
  getParentRoute: () => rootRouteImport,
} as any)
const GetStartedRoute = GetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R401Route = R401RouteImport.update({
  id: '/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
  id: '/resources/',
  path: '/resources/',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsProfessionalsRoute = SolutionsProfessionalsRouteImport.update({
  id: '/solutions/professionals',
  path: '/solutions/professionals',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsConsultingRoute = SolutionsConsultingRouteImport.update({
  id: '/solutions/consulting',
  path: '/solutions/consulting',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsClientsRoute = SolutionsClientsRouteImport.update({
  id: '/solutions/clients',
  path: '/solutions/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesResearchRoute = ResourcesResearchRouteImport.update({
  id: '/resources/research',
  path: '/resources/research',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesCaseStudiesRoute = ResourcesCaseStudiesRouteImport.update({
  id: '/resources/case-studies',
  path: '/resources/case-studies',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesBlogRoute = ResourcesBlogRouteImport.update({
  id: '/resources/blog',
  path: '/resources/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalSubprocessorsRoute = LegalSubprocessorsRouteImport.update({
  id: '/legal/subprocessors',
  path: '/legal/subprocessors',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPlatformEulaRoute = LegalPlatformEulaRouteImport.update({
  id: '/legal/platform-eula',
  path: '/legal/platform-eula',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalIntendedPurposeRoute = LegalIntendedPurposeRouteImport.update({
  id: '/legal/intended-purpose',
  path: '/legal/intended-purpose',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalEulaRoute = LegalEulaRouteImport.update({
  id: '/legal/eula',
  path: '/legal/eula',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalDpaRoute = LegalDpaRouteImport.update({
  id: '/legal/dpa',
  path: '/legal/dpa',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesResearchSlugRoute = ResourcesResearchSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ResourcesResearchRoute,
} as any)
const ResourcesCaseStudiesSlugRoute =
  ResourcesCaseStudiesSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => ResourcesCaseStudiesRoute,
  } as any)
const ResourcesBlogSlugRoute = ResourcesBlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ResourcesBlogRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/401': typeof R401Route
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/contact-us': typeof ContactUsRoute
  '/cookies': typeof CookiesRoute
  '/get-started': typeof GetStartedRoute
  '/loading': typeof LoadingRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/trust': typeof TrustRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/legal/eula': typeof LegalEulaRoute
  '/legal/intended-purpose': typeof LegalIntendedPurposeRoute
  '/legal/platform-eula': typeof LegalPlatformEulaRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/resources/blog': typeof ResourcesBlogRouteWithChildren
  '/resources/case-studies': typeof ResourcesCaseStudiesRouteWithChildren
  '/resources/research': typeof ResourcesResearchRouteWithChildren
  '/solutions/clients': typeof SolutionsClientsRoute
  '/solutions/consulting': typeof SolutionsConsultingRoute
  '/solutions/professionals': typeof SolutionsProfessionalsRoute
  '/resources/': typeof ResourcesIndexRoute
  '/resources/blog/$slug': typeof ResourcesBlogSlugRoute
  '/resources/case-studies/$slug': typeof ResourcesCaseStudiesSlugRoute
  '/resources/research/$slug': typeof ResourcesResearchSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/401': typeof R401Route
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/contact-us': typeof ContactUsRoute
  '/cookies': typeof CookiesRoute
  '/get-started': typeof GetStartedRoute
  '/loading': typeof LoadingRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/trust': typeof TrustRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/legal/eula': typeof LegalEulaRoute
  '/legal/intended-purpose': typeof LegalIntendedPurposeRoute
  '/legal/platform-eula': typeof LegalPlatformEulaRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/resources/blog': typeof ResourcesBlogRouteWithChildren
  '/resources/case-studies': typeof ResourcesCaseStudiesRouteWithChildren
  '/resources/research': typeof ResourcesResearchRouteWithChildren
  '/solutions/clients': typeof SolutionsClientsRoute
  '/solutions/consulting': typeof SolutionsConsultingRoute
  '/solutions/professionals': typeof SolutionsProfessionalsRoute
  '/resources': typeof ResourcesIndexRoute
  '/resources/blog/$slug': typeof ResourcesBlogSlugRoute
  '/resources/case-studies/$slug': typeof ResourcesCaseStudiesSlugRoute
  '/resources/research/$slug': typeof ResourcesResearchSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/401': typeof R401Route
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/contact-us': typeof ContactUsRoute
  '/cookies': typeof CookiesRoute
  '/get-started': typeof GetStartedRoute
  '/loading': typeof LoadingRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/trust': typeof TrustRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/legal/eula': typeof LegalEulaRoute
  '/legal/intended-purpose': typeof LegalIntendedPurposeRoute
  '/legal/platform-eula': typeof LegalPlatformEulaRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/resources/blog': typeof ResourcesBlogRouteWithChildren
  '/resources/case-studies': typeof ResourcesCaseStudiesRouteWithChildren
  '/resources/research': typeof ResourcesResearchRouteWithChildren
  '/solutions/clients': typeof SolutionsClientsRoute
  '/solutions/consulting': typeof SolutionsConsultingRoute
  '/solutions/professionals': typeof SolutionsProfessionalsRoute
  '/resources/': typeof ResourcesIndexRoute
  '/resources/blog/$slug': typeof ResourcesBlogSlugRoute
  '/resources/case-studies/$slug': typeof ResourcesCaseStudiesSlugRoute
  '/resources/research/$slug': typeof ResourcesResearchSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/401'
    | '/404'
    | '/about'
    | '/contact'
    | '/contact-us'
    | '/cookies'
    | '/get-started'
    | '/loading'
    | '/pricing'
    | '/privacy'
    | '/trust'
    | '/legal/dpa'
    | '/legal/eula'
    | '/legal/intended-purpose'
    | '/legal/platform-eula'
    | '/legal/subprocessors'
    | '/resources/blog'
    | '/resources/case-studies'
    | '/resources/research'
    | '/solutions/clients'
    | '/solutions/consulting'
    | '/solutions/professionals'
    | '/resources/'
    | '/resources/blog/$slug'
    | '/resources/case-studies/$slug'
    | '/resources/research/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/401'
    | '/404'
    | '/about'
    | '/contact'
    | '/contact-us'
    | '/cookies'
    | '/get-started'
    | '/loading'
    | '/pricing'
    | '/privacy'
    | '/trust'
    | '/legal/dpa'
    | '/legal/eula'
    | '/legal/intended-purpose'
    | '/legal/platform-eula'
    | '/legal/subprocessors'
    | '/resources/blog'
    | '/resources/case-studies'
    | '/resources/research'
    | '/solutions/clients'
    | '/solutions/consulting'
    | '/solutions/professionals'
    | '/resources'
    | '/resources/blog/$slug'
    | '/resources/case-studies/$slug'
    | '/resources/research/$slug'
  id:
    | '__root__'
    | '/'
    | '/401'
    | '/404'
    | '/about'
    | '/contact'
    | '/contact-us'
    | '/cookies'
    | '/get-started'
    | '/loading'
    | '/pricing'
    | '/privacy'
    | '/trust'
    | '/legal/dpa'
    | '/legal/eula'
    | '/legal/intended-purpose'
    | '/legal/platform-eula'
    | '/legal/subprocessors'
    | '/resources/blog'
    | '/resources/case-studies'
    | '/resources/research'
    | '/solutions/clients'
    | '/solutions/consulting'
    | '/solutions/professionals'
    | '/resources/'
    | '/resources/blog/$slug'
    | '/resources/case-studies/$slug'
    | '/resources/research/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R401Route: typeof R401Route
  R404Route: typeof R404Route
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  ContactUsRoute: typeof ContactUsRoute
  CookiesRoute: typeof CookiesRoute
  GetStartedRoute: typeof GetStartedRoute
  LoadingRoute: typeof LoadingRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  TrustRoute: typeof TrustRoute
  LegalDpaRoute: typeof LegalDpaRoute
  LegalEulaRoute: typeof LegalEulaRoute
  LegalIntendedPurposeRoute: typeof LegalIntendedPurposeRoute
  LegalPlatformEulaRoute: typeof LegalPlatformEulaRoute
  LegalSubprocessorsRoute: typeof LegalSubprocessorsRoute
  ResourcesBlogRoute: typeof ResourcesBlogRouteWithChildren
  ResourcesCaseStudiesRoute: typeof ResourcesCaseStudiesRouteWithChildren
  ResourcesResearchRoute: typeof ResourcesResearchRouteWithChildren
  SolutionsClientsRoute: typeof SolutionsClientsRoute
  SolutionsConsultingRoute: typeof SolutionsConsultingRoute
  SolutionsProfessionalsRoute: typeof SolutionsProfessionalsRoute
  ResourcesIndexRoute: typeof ResourcesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trust': {
      id: '/trust'
      path: '/trust'
      fullPath: '/trust'
      preLoaderRoute: typeof TrustRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loading': {
      id: '/loading'
      path: '/loading'
      fullPath: '/loading'
      preLoaderRoute: typeof LoadingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/401': {
      id: '/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof R401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/': {
      id: '/resources/'
      path: '/resources'
      fullPath: '/resources/'
      preLoaderRoute: typeof ResourcesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/professionals': {
      id: '/solutions/professionals'
      path: '/solutions/professionals'
      fullPath: '/solutions/professionals'
      preLoaderRoute: typeof SolutionsProfessionalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/consulting': {
      id: '/solutions/consulting'
      path: '/solutions/consulting'
      fullPath: '/solutions/consulting'
      preLoaderRoute: typeof SolutionsConsultingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/clients': {
      id: '/solutions/clients'
      path: '/solutions/clients'
      fullPath: '/solutions/clients'
      preLoaderRoute: typeof SolutionsClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/research': {
      id: '/resources/research'
      path: '/resources/research'
      fullPath: '/resources/research'
      preLoaderRoute: typeof ResourcesResearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/case-studies': {
      id: '/resources/case-studies'
      path: '/resources/case-studies'
      fullPath: '/resources/case-studies'
      preLoaderRoute: typeof ResourcesCaseStudiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/blog': {
      id: '/resources/blog'
      path: '/resources/blog'
      fullPath: '/resources/blog'
      preLoaderRoute: typeof ResourcesBlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/subprocessors': {
      id: '/legal/subprocessors'
      path: '/legal/subprocessors'
      fullPath: '/legal/subprocessors'
      preLoaderRoute: typeof LegalSubprocessorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/platform-eula': {
      id: '/legal/platform-eula'
      path: '/legal/platform-eula'
      fullPath: '/legal/platform-eula'
      preLoaderRoute: typeof LegalPlatformEulaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/intended-purpose': {
      id: '/legal/intended-purpose'
      path: '/legal/intended-purpose'
      fullPath: '/legal/intended-purpose'
      preLoaderRoute: typeof LegalIntendedPurposeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/eula': {
      id: '/legal/eula'
      path: '/legal/eula'
      fullPath: '/legal/eula'
      preLoaderRoute: typeof LegalEulaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/dpa': {
      id: '/legal/dpa'
      path: '/legal/dpa'
      fullPath: '/legal/dpa'
      preLoaderRoute: typeof LegalDpaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/research/$slug': {
      id: '/resources/research/$slug'
      path: '/$slug'
      fullPath: '/resources/research/$slug'
      preLoaderRoute: typeof ResourcesResearchSlugRouteImport
      parentRoute: typeof ResourcesResearchRoute
    }
    '/resources/case-studies/$slug': {
      id: '/resources/case-studies/$slug'
      path: '/$slug'
      fullPath: '/resources/case-studies/$slug'
      preLoaderRoute: typeof ResourcesCaseStudiesSlugRouteImport
      parentRoute: typeof ResourcesCaseStudiesRoute
    }
    '/resources/blog/$slug': {
      id: '/resources/blog/$slug'
      path: '/$slug'
      fullPath: '/resources/blog/$slug'
      preLoaderRoute: typeof ResourcesBlogSlugRouteImport
      parentRoute: typeof ResourcesBlogRoute
    }
  }
}

interface ResourcesBlogRouteChildren {
  ResourcesBlogSlugRoute: typeof ResourcesBlogSlugRoute
}

const ResourcesBlogRouteChildren: ResourcesBlogRouteChildren = {
  ResourcesBlogSlugRoute: ResourcesBlogSlugRoute,
}

const ResourcesBlogRouteWithChildren = ResourcesBlogRoute._addFileChildren(
  ResourcesBlogRouteChildren,
)

interface ResourcesCaseStudiesRouteChildren {
  ResourcesCaseStudiesSlugRoute: typeof ResourcesCaseStudiesSlugRoute
}

const ResourcesCaseStudiesRouteChildren: ResourcesCaseStudiesRouteChildren = {
  ResourcesCaseStudiesSlugRoute: ResourcesCaseStudiesSlugRoute,
}

const ResourcesCaseStudiesRouteWithChildren =
  ResourcesCaseStudiesRoute._addFileChildren(ResourcesCaseStudiesRouteChildren)

interface ResourcesResearchRouteChildren {
  ResourcesResearchSlugRoute: typeof ResourcesResearchSlugRoute
}

const ResourcesResearchRouteChildren: ResourcesResearchRouteChildren = {
  ResourcesResearchSlugRoute: ResourcesResearchSlugRoute,
}

const ResourcesResearchRouteWithChildren =
  ResourcesResearchRoute._addFileChildren(ResourcesResearchRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R401Route: R401Route,
  R404Route: R404Route,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  ContactUsRoute: ContactUsRoute,
  CookiesRoute: CookiesRoute,
  GetStartedRoute: GetStartedRoute,
  LoadingRoute: LoadingRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  TrustRoute: TrustRoute,
  LegalDpaRoute: LegalDpaRoute,
  LegalEulaRoute: LegalEulaRoute,
  LegalIntendedPurposeRoute: LegalIntendedPurposeRoute,
  LegalPlatformEulaRoute: LegalPlatformEulaRoute,
  LegalSubprocessorsRoute: LegalSubprocessorsRoute,
  ResourcesBlogRoute: ResourcesBlogRouteWithChildren,
  ResourcesCaseStudiesRoute: ResourcesCaseStudiesRouteWithChildren,
  ResourcesResearchRoute: ResourcesResearchRouteWithChildren,
  SolutionsClientsRoute: SolutionsClientsRoute,
  SolutionsConsultingRoute: SolutionsConsultingRoute,
  SolutionsProfessionalsRoute: SolutionsProfessionalsRoute,
  ResourcesIndexRoute: ResourcesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
